export enum MemberRowMode {
  editRoles = 'editRoles',
  removeUser = 'removeUser',
  default = 'default',
}

export enum MemberRowAction {
  approve = 'approveRequest',
  reject = 'rejectRequest',
  remove = 'remove',
  editRoles = 'editRoles',
}

export type MemberRowStateType = {
  action: string;
};
